import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-641ad3b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["selected", "floating", "isActive"]


export default /*#__PURE__*/_defineComponent({
  __name: 'userTableCellWrapper',
  props: {
    selected: { type: Boolean },
    floating: { type: Boolean },
    isActive: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "users-table--cell-wrapper",
    selected: __props.selected,
    floating: __props.floating,
    isActive: __props.isActive
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}
}

})